/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    string, shape, bool, number,
} from 'prop-types';

const useStyles = makeStyles(({
    productImage: {
        display: 'block',
        width: 'inherit',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
}));

const ProductImage = ({
    image, name, absoluteImagePath, positionInCategory,
}) => {
    const classes = useStyles();

    const productImageLoading = () => (positionInCategory < 4 ? 'eager' : 'lazy');

    // REDO ALL THIS TO JUST PULL IN PJPEG FROM FASTLY?
    // url of the current image in the card
    // Must have complex expression to render correctly on server (useEffect does not run)
    const generateCurrentImageSrc = () => {
        if (image?.collectionImage && image?.collectionImage !== '') {
            return (`${image?.path}${image.collectionImage}x.jpg?height=456&width=418&sharpen=a0.5,r1,t1&quality=80&auto=webp&optimize={medium}`);
        }
        return image?.fullPath
            // Qubit Images
            ? (`${image.fullPath}?height=456&width=418&sharpen=a0.5,r1,t1&quality=80&auto=webp&optimize={medium}`)
            : (`${absoluteImagePath ? image : `${image?.path}${image?.name}x.jpg`}?height=456&width=418&sharpen=a0.5,r1,t1&quality=80&auto=webp&optimize={medium}`);
    };

    return (
        <img
            // This src is a temp solution until a brand specific more complete url comes from the back end.
            src={generateCurrentImageSrc()}
            alt={name}
            className={classes.productImage}
            loading={productImageLoading()}
        />
    );
};

ProductImage.propTypes = {
    name: string.isRequired,
    image: shape({
        name: string.isRequired,
        path: string.isRequired,
        fullPath: string.isRequired,

    }).isRequired,
    absoluteImagePath: bool,
    positionInCategory: number,
};

ProductImage.defaultProps = {
    absoluteImagePath: false,
    positionInCategory: 0,
};

export default ProductImage;
